module.exports = {"530629101":"扎西镇","530629102":"旧城镇","530629103":"罗布镇","530629104":"林凤镇","530629105":"长安镇","530629106":"庙沟镇","530629107":"水田镇","530629201":"双河苗族彝族乡","530629202":"高田乡","530629207":"三桃乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530629.json
// module id = 2398
// module chunks = 0